import React, {useCallback, useEffect} from 'react';
import {useDispatch, useSelector} from 'react-redux';

import * as S from './HomePage.styles';

import PopularDestinations from './containers/PopularDestinations';
import NavigationDownCircle from '../../../stories/Icons/NavigationDownCircle';
import RecentSearch from './containers/RecentSearch';
import SearchBlock from './containers/SearchBlock';
import SegmentSlider from './containers/SegmentSlider';
import HotelsHomeHelmet from './containers/hotels-home-helmet';
import SeoFaq from './containers/SeoFaq';
import {fetchOffersDataThunk} from './redux/thunks';
import OfferCarousel from './containers/OfferCarousel';
import TopDestinations from './containers/TopDestinations';
import AdSlotUI from '../../../stories/components/hotels/HomePage/AdSlotUI/AdSlotUI';
import {hotelsPartnerFn} from '@stencil/hotels-common-reducer/src/selectors';
import {resetSelectedProperty} from '@stencil/hotels-common-reducer/src/actions';
import {offersApiSelectorFn} from './redux/selectors';
import {pushga} from 'ga-utils';
import {HotelsDwebGenericEvent, HomePageGAEvents} from '../../config/ga-config';
import SmartEngageApiContainer from '../SmartEngage/containers/SmartEngageApiContainer';

// import OfferCarouselLoader from '../../../stories/components/hotels/HomePage/OfferCarouselLoader/OfferCarouselLoader';
import {gaGoogleRTThunk} from '@stencil/hotels-ga/src/thunks';

const HomePage = () => {
  const dispatch = useDispatch();
  const partner = useSelector(hotelsPartnerFn);

  const {data: offersDataFromState, isLoading: isOffersCarouselLoading} = useSelector(
    offersApiSelectorFn,
  );

  const fetchOffersDataThunkCaller = useCallback(() => {
    return dispatch(fetchOffersDataThunk());
  }, [dispatch]);

  const pushGoogleRTGAThunk = useCallback(() => {
    return dispatch(gaGoogleRTThunk('home'));
  }, [dispatch]);

  useEffect(() => {
    fetchOffersDataThunkCaller();
    pushGoogleRTGAThunk();
    dispatch(resetSelectedProperty());
  }, []);

  const exploreMoreClickHandler = () => {
    window.scrollTo({behavior: 'smooth', top: 650});
    pushga({
      eventCategory: HotelsDwebGenericEvent,
      eventAction: HomePageGAEvents.hotelHomePageClicks.action.exploreMoreClicked,
    });
  };

  const homePageBannerClickHandler = () => {
    pushga({
      eventCategory: HomePageGAEvents.hotelHomePageClicks.category,
      eventAction: HomePageGAEvents.hotelHomePageClicks.action.hotelsHomeBannerAdClick,
    });
  };

  return (
    <S.HomeBodyWrapperSection>
      <S.HomeBodyWrapperContentDiv>
        {(partner === 'gostays' && (
          <S.HomePageTitle>Book Handpicked Hotels With Certified Quality</S.HomePageTitle>
        )) || <S.HomePageTitle>Book Domestic & International Hotels</S.HomePageTitle>}
        <SmartEngageApiContainer page="home" />
        <S.BackBlueRoundDark />
        <S.BackBlueRoundLight />
        <S.SearchBlockOuterWrapper>
          <HotelsHomeHelmet />
          <SearchBlock />

          <OfferCarousel offersDataFromState={offersDataFromState} />
        </S.SearchBlockOuterWrapper>
        <S.ExploreMoreBtn onClick={exploreMoreClickHandler}>
          <S.ExploreBtnText>Explore More </S.ExploreBtnText>
          <NavigationDownCircle />
        </S.ExploreMoreBtn>
        <RecentSearch />
        <TopDestinations />
        <S.AdsUIWrapper>
          <AdSlotUI homePageBannerClickHandler={homePageBannerClickHandler} />
        </S.AdsUIWrapper>
        <SegmentSlider />
        <PopularDestinations />
        {partner === 'hotels' ? (
          <SeoFaq datakey={'dh_home_json'} />
        ) : (
          <SeoFaq datakey={'gostays_home_json_v2'} />
        )}
      </S.HomeBodyWrapperContentDiv>
      {/* <S.PageOverlay /> */}
    </S.HomeBodyWrapperSection>
  );
};

export default HomePage;
